import {axios} from "@/utils"

const endpoints = {
    get_media_url: "/v1/shared-image/"
}

export default {
    getMediaUrl: async ({hash, user_id, media_id}) => {
        try {
            const {data} = await axios.post(endpoints.get_media_url, {
                security_hash:hash,
                user_id: user_id,
                media_id: media_id
            })
            return {
                is_valid: true,
                ...data
            }
        } catch (e) {
            if (e.response && e.response.status === 400)
                return {is_valid: false,}
            else
                throw e
        }
    }
}